import React from 'react';

export interface VoxelLoadingSpinnerProps {
  className?: string;
  sizeClass?: string;
  color?: 'blue' | 'gray';
}

export const VoxelLoadingSpinner: React.FC<VoxelLoadingSpinnerProps> = ({
  className,
  sizeClass = 'h-4 w-4',
  color = 'gray',
}) => {
  let colorClass = '';
  if (color === 'blue') {
    colorClass = 'border-t-voxel-blue-400 border-l-voxel-blue-200';
  }
  if (color === 'gray') {
    colorClass = 'border-t-voxel-gray-400 border-l-voxel-gray-200';
  }

  const innerClasses = `
    ${sizeClass}
    rounded-full border-[2px] border-b-transparent border-r-transparent
    ${colorClass}
    block absolute
  `;

  return (
    <div className={`relative project-status-item-ring ${sizeClass} ${className}`}>
      <div className={innerClasses} />
      <div className={innerClasses} />
      <div className={innerClasses} />
      <div className={innerClasses} />
    </div>
  );
};

export default VoxelLoadingSpinner;
